const BroadcasterComponent = {
  mounted() {
    console.log('BroadcasterComponent mounted');
    import(/* webpackPrefetch: true */ './broadcaster.js').then( ({ Broadcaster }) => {
      this._broadcaster = new Broadcaster(this);
    })
  },
  disconnected() { console.log('BroadcasterComponent disconnected') },
  reconnected()  { console.log('BroadcasterComponent reconnected') },
  updated()      { console.log('BroadcasterComponent updated'); },
  destroyed()    {
    console.log('BroadcasterComponent destroyed');
    this._broadcaster.destroyAll()
  }
}

const Cam2Cam = {
  mounted() {
    console.log("C2C component mounted")
    import(/* webpackPrefetch: true */ './broadcaster.js').then( ({ Cam2CamBroadcaster }) => {
      this._broadcaster = new Cam2CamBroadcaster(this);
    })
  },
  destroyed()    {
    console.log('C2C component destroy');
    this._broadcaster.destroyAll()
  },
}
export default { BroadcasterComponent, Cam2Cam }
